import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as roomType from '../room-type'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: roomType.RESOURCE.payload.dimension.partialId,
      partialId: roomType.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Does it support a laboratory?',
    isOptional: false,
    name: 'Is Lab Service?',
    partialId: PartialId.Standard.create('is_lab_srv'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
